import React from 'react';
import { PageTitle } from '../../../../rbts/layout/core';
import { Vista } from './components/Vista';

const RemanentePage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Reporte de Remanente de Tickets</PageTitle>
      <Vista />
    </>
  );
};

export { RemanentePage };
